import { React } from 'react';
import { Link } from 'react-router-dom';

// pipes
import { DisplayDate } from "shared/pipes/display-date";

// components
import { ChargeButton } from "./charge-button";
import { ExemptButton } from "./exempt-button";

const LateRow = ({ box, count }) => {

    if (!box) { return null; }
    const { user, createdAt, declared_late } = box;

    return (
        <tr id={count}>
            <th>{user && user.full_name}</th>
            <th>
                {user && (
                    <Link target="_blank" to={`/closet-hackers/${user.id}`}>{user.email}</Link>
                )}
            </th>
            <th>
                <DisplayDate>
                    {createdAt.seconds}
                </DisplayDate>
            </th>
            <th>
                <DisplayDate>
                    {declared_late}
                </DisplayDate>
            </th>
            <th width="5%">
                <ExemptButton box={box} />
            </th>
            <th width="5%">
                <ChargeButton box={box} />
            </th>
        </tr>
    );
}

export { LateRow };
